<script>
export default { };
</script>

<template>
    <div class="Container">
        <slot></slot>
    </div>
</template>

<style lang="stylus" scoped>
.Container
    max-width 100%
    width 1170px
    box-sizing content-box
    margin 0 auto
    padding 70px 20px 20px
</style>


